// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export class WatchlistSheetItem {
    constructor(name, symbolIds = new Set()) {
        this._symbolIds = new Set();
        this.name = name;
        this._symbolIds = symbolIds;
    }
    getSymbolIds() {
        return Array.from(this._symbolIds);
    }
    has(symbolId) {
        return this._symbolIds.has(symbolId);
    }
    add(symbolId) {
        this._symbolIds.add(symbolId);
    }
    delete(symbolId) {
        this._symbolIds.delete(symbolId);
    }
    set(symbolIds) {
        this._symbolIds = symbolIds;
    }
    clear() {
        if (this._symbolIds.size !== 0) {
            this._symbolIds.clear();
        }
    }
    serialize() {
        return JSON.stringify(this);
    }
    static deserialize(json) {
        const obj = JSON.parse(json);
        return new WatchlistSheetItem(obj.name, obj.symbolIds);
    }
}
